export const AUTH_TOKEN = "auth_token";
export const AUTH_TYPE = "auth_type";
export const AUTH_ROLES = "auth_roles";
export const AUTH_ID = "auth_id";
export const AUTH_NAME = "auth_name";
export const AUTH_USER = "auth_USER";
export const ADMIN_TYPE = "ADMIN";
export const SUBADMIN_TYPE = "SUB_ADMIN";

export const ContactUsStatus = ["Pending", "Accepted", "Completed", "Rejected"];
